import moment from "moment";
import { apiCall } from "./action";
import config_settings from "../config/config";

// Intercom is production-only; ENV comes from the host entry in config.js
export const isIntercomEnabled = () => {
  const host = window.location.origin.toLowerCase().replace(/^https?:\/\//, "");
  return config_settings[host]?.ENV === "PROD";
};

// session storage is the single source of the user details handed to Intercom,
// so the snippet in public/index.html and the app stay in sync on a reload
const getSessionValue = (key) => {
  const value = sessionStorage.getItem(key);
  return value && value !== "null" && value !== "undefined" ? value : "";
};

// created_at is kept as MM/DD/YYYY, the format the Intercom snippet expects
const toCreatedAtDate = (value) => {
  if (!value) return "";
  if (/^\d+$/.test(String(value))) return moment.unix(Number(value)).format("MM/DD/YYYY");
  const date = moment(String(value), ["MM/DD/YYYY", moment.ISO_8601, "YYYY-MM-DD HH:mm:ss"], true);
  return date.isValid() ? date.format("MM/DD/YYYY") : "";
};

// keeps the user fields Intercom needs (email/created_at are not stored on login otherwise)
export const storeIntercomUserDetails = ({ email, createdAt }) => {
  if (email) sessionStorage.setItem("user_email", email);
  const created = toCreatedAtDate(createdAt);
  if (created) sessionStorage.setItem("user_created_at", created);
};

// pushes name, created_at and the JWT into the snippet's settings
// user_id/email are intentionally excluded from the Intercom SDK payload
export const bootIntercomUser = () => {
  if (!isIntercomEnabled()) return;
  const name = getSessionValue("user_name");
  const createdAt = toCreatedAtDate(getSessionValue("user_created_at"));
  const jwt = getSessionValue("intercom_user_jwt");
  const settings = {
    ...(window.intercomSettings || {}),
    ...(name && { name: name }),
    ...(createdAt && { created_at: createdAt }),
    ...(jwt && { intercom_user_jwt: jwt }),
  };
  window.intercomSettings = settings;
  if (typeof window.Intercom === "function") window.Intercom("boot", settings);
};

// fetches the signed JWT for identity verification and boots Intercom with it
export const initIntercom = () => {
  if (!isIntercomEnabled()) return;
  const formdata = {
    userid: getSessionValue("user_id"),
    useremail: getSessionValue("user_email"),
  };
  return apiCall(
    (response) => {
      const token = response?.data?.data;
      if (response?.data?.success && token) {
        sessionStorage.setItem("intercom_user_jwt", token);
      } else {
        console.log("generate-intercom-token", response?.data?.message);
      }
      bootIntercomUser();
    },
    formdata,
    "GENERATE_INTERCOM_TOKEN"
  );
};
